import React from 'react';
import './Promotion.css';
const Promotion = () => {
    return (
        <div className='inner mainpro'>
            <div>
                <img src="images/mainbanner_02.png" alt="" />
            </div>
            <div className='text'>
                <h3>22/23 마이다스 윈터캐슬</h3>
                <p>2022.12 ~ 2023.02</p>
                <div>
                마이다스 겨울 이야기 <br/>
                ▶ 겨울놀이 체험존<br/>
                ▶ 겨울낚시 체험존<br/>
                ▶ 겨울맛캉스
                </div>
                <span>VIEW</span>
            </div>
        </div>
    );
};

export default Promotion;